import React from 'react';
import { useTranslation } from '../i18n';
export function SocialProof() {
  const {
    t
  } = useTranslation();
  const logos = [{
    name: 'Visit Beni Mellal-Khénifra',
    active: true
  }, {
    name: 'Visit Draa-Tafilalet',
    active: true
  }, {
    name: 'Lumi Morocco',
    active: true
  }, {
    name: 'CASBAH',
    active: true
  }, {
    name: 'HappyTaux',
    active: true
  }];
  return <section className="py-12 bg-[#0A0A0A] border-y border-white/5 relative z-20" data-id="element-294">
      <div className="max-w-7xl mx-auto px-6" data-id="element-295">
        <p className="text-center text-sm font-medium text-white/40 mb-8 uppercase tracking-widest" data-id="element-296">
          {t('socialProof.trusted')}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12" data-id="element-297">
          {logos.map((logo, idx) => <div key={idx} className={`px-6 py-3 rounded-xl border flex items-center justify-center min-w-[140px] ${logo.active ? 'bg-white/5 border-white/10' : 'bg-white/[0.02] border-white/5'}`} data-id="element-298">
              <span className={`font-bold text-lg tracking-wide ${logo.active ? 'text-white/30' : 'text-white/15 italic'}`} data-id="element-299">
                {logo.name}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}